import { render, staticRenderFns } from "./CalculateDetail.vue?vue&type=template&id=89f7d086"
import script from "./CalculateDetail.vue?vue&type=script&lang=js"
export * from "./CalculateDetail.vue?vue&type=script&lang=js"
import style0 from "./CalculateDetail.vue?vue&type=style&index=0&id=89f7d086&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CalculateDetail.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports